import { render, staticRenderFns } from "./ArtigoModal.vue?vue&type=template&id=6346df50&scoped=true&"
import script from "./ArtigoModal.vue?vue&type=script&lang=js&"
export * from "./ArtigoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346df50",
  null
  
)

export default component.exports